import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const LOAD_ACCOUNT = 'LOAD_ACCOUNT';
export const LOAD_ACCOUNT_DATA = 'LOAD_ACCOUNT_DATA';
export const LOAD_ACCOUNT_DATA_FAILURE = 'LOAD_ACCOUNT_DATA_FAILURE';
export const LINK_ACCOUNT_CUSTOMER = 'LINK_ACCOUNT_CUSTOMER';
export const UNLINK_ACCOUNT_CUSTOMER = 'UNLINK_ACCOUNT_CUSTOMER';
export const UNLINK_ACCOUNT_FORM = 'UNLINK_ACCOUNT_FORM';
export const LINK_ACCOUNT_FORM = 'LINK_ACCOUNT_FORM';
export const CLEAR_ACCOUNT_REQUEST = 'CLEAR_ACCOUNT_REQUEST';

function requestLoadAccount(account) {
  return {
    type: LOAD_ACCOUNT,
    storeAccount: account
  };
}

function requestLoadAccountData() {
  return {
    type: LOAD_ACCOUNT_DATA,
  };
}

function clearAccount() {
  return {
    type: CLEAR_ACCOUNT_REQUEST,
  };
}

function requestLinkAccountCustomer() {
  return {
    type: LINK_ACCOUNT_CUSTOMER,
  };
}

function requestUnlinkAccountCustomer() {
  return {
    type: UNLINK_ACCOUNT_CUSTOMER,
  };
}

function requestUnlinkAccountForm() {
  return {
    type: UNLINK_ACCOUNT_FORM,
  };
}

function requestLinkAccountForm() {
  return {
    type: LINK_ACCOUNT_FORM,
  };
}

function rejectAccountDataLoad(accountDataLoadError) {
  return {
    type: LOAD_ACCOUNT_DATA_FAILURE,
    accountDataLoadError
  };
}

export function accountDataLoad(accountId) {
  return (dispatch) => {
    dispatch(requestLoadAccountData());

    const promise = () => ApiService
      .getAccountData(accountId)
      .then((response) => {
        dispatch(requestLoadAccount(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        dispatch(handleException(error, rejectAccountDataLoad));
      });

    return promise();
  };
}

export function clearAccountData() {
  return dispatch => dispatch(clearAccount());
}

export function accountCustomerLink(accountId, addedCustomerData) {
  return (dispatch) => {
    dispatch(requestLinkAccountCustomer());

    const accountCustomer = {
      CustomerId: addedCustomerData.customerId,
      Capacity: addedCustomerData.capacity,
      ValidFrom: addedCustomerData.validFrom,
      ValidUntil: addedCustomerData.validUntil,
      Account: {
        id: accountId
      }
    };

    const customerAccount = [accountCustomer];

    const promise = () => ApiService
      .linkCustomerAccount(addedCustomerData.customerId, customerAccount)
      .then((response) => {
        dispatch(accountDataLoad(accountId));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, true, true));
        }
      });
    return promise();
  };
}

export function accountCustomerUnlink(accountId, customerId) {
  const accountCustomer = [accountId];

  return (dispatch) => {
    dispatch(requestUnlinkAccountCustomer());

    const promise = () => ApiService
      .unLinkCustomerAccount(customerId, accountCustomer)
      .then((response) => {
        dispatch(accountDataLoad(accountId));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, true));
        }
      });
    return promise();
  };
}

export function accountFormUnlink(accountId, formId) {
  const formIds = [formId];

  return (dispatch) => {
    dispatch(requestUnlinkAccountForm());

    const promise = () => ApiService
      .unLinkAccountForm(accountId, formIds)
      .then((response) => {
        dispatch(accountDataLoad(accountId));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, true));
        }
      });
    return promise();
  };
}

export function accountFormLink(accountId, formId) {
  return (dispatch) => {
    dispatch(requestLinkAccountForm());

    const promise = () => ApiService
      .linkAccountForm(accountId, formId)
      .then((response) => {
        dispatch(accountDataLoad(accountId));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, true, true));
        }
      });
    return promise();
  };
}
